import type { Comparison } from '@makemydeal/dr-dash-bff-types';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export const getComparisonList = (state: StateTree): Comparison[] => {
    return state.comparison.comparisonList;
};

/**
 *  Will return the active comparison. Will only be populated if the comparison matches the latest DXG version
 * */
export const getActiveComparison = (state: StateTree): Comparison | undefined => {
    return state.comparison.activeComparison;
};

/**
 * US2041815: the compressed payment grid item for the active comparison, as it was stored.
 *
 * Gated here rather than where it is extracted. `comparisonReducer` pulls it out of the deal's baggage the
 * way `baggageFuelEconomyReducer` and `offerInfoReducer` pull out theirs — from `action.payload.baggage`,
 * which carries feature toggles on bootstrap but not on the save-success and comparison-update actions
 * that also refresh it. Gating the single read instead makes the item unobservable with the toggle off,
 * which is what actually matters, without leaving the reducer gated on one path and open on two.
 */
export const getPaymentGridBaggagePayload = (state: StateTree) =>
    featureToggleSelectors.isPaymentGridBaggageCompressionEnabled(state) ? state.comparison?.paymentGridPayload : undefined;

/**
 * Return the published comparison with the given deal version if there is one; undefined otherwise,
 * Note that if save draft is enabled, a comparison in the baggage may not be published.
 */
export const getComparisonByDealVersion = (dealVersion: string, state: StateTree): Comparison | undefined => {
    const list = getComparisonList(state) || [];
    const comparison = list.find((item: any) => {
        return item?.isPublished && item.dealXgVersionId === dealVersion;
    });

    return comparison;
};

export const getComparisonState = (state: StateTree) => state.comparison;

export const isMoreRecentVersionAvailable = (state: StateTree): boolean => getComparisonState(state).isMoreRecentVersionAvailable;

export const isOutOfBandBannerDisplayed = (state: StateTree): boolean => getComparisonState(state).outOfBandBannerDisplayed;
